export interface UserState {
    id_token?: string;
    idTokenClaims: IdTokenClaims;
    access_token?: string;
    name: string | null;
    username: string | null;
    loggedIn: boolean;
    error: string | null;
}

export interface IdTokenClaims {
    aio: string;
    aud: string;
    iss: string;
    name: string;
    oid: string;
    preferred_username: string;
    roles?: string[];
    tid: string;
    ver: string;
}
